import { Record } from 'immutable';
import { ChatFilters } from 'find-and-filter-data/search-and-filter-schema/protected';
const FilterKey = Record({
  filterValues: new ChatFilters(),
  sortOrder: null
}, 'FilterKey');
export default FilterKey;